import { render, staticRenderFns } from "./AppLivePlatform.vue?vue&type=template&id=415394e0&lang=pug&"
import script from "./AppLivePlatform.vue?vue&type=script&lang=ts&"
export * from "./AppLivePlatform.vue?vue&type=script&lang=ts&"
import style0 from "./AppLivePlatform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports